import React from "react";

// components
import { ButtonStandard, Text } from "@performyard/py-components";

import Spacer from "../../../../../components/Spacer";
import { PYSurveyContainer } from "./components/PYSurveyContainer";

interface SurveyUnavailableProps {
	illustration: React.ReactNode;
	message: string;
	testId?: string;
}

export const SurveyUnavailable = ({ illustration, message, testId }: SurveyUnavailableProps) => {
	return (
		<PYSurveyContainer testId={testId}>
			<div className="flex h-[500px] w-full max-w-[880px] flex-col items-center justify-center rounded-[4px] bg-neutral-0">
				<div className="flex w-full max-w-[370px] flex-col items-center justify-center gap-4 text-center">
					{illustration}
					<Text size="paragraph-2" weight="semi-bold">
						{message}
					</Text>
					<Spacer height={2} />
					<div className="flex items-center justify-center gap-2">
						<a href="/">
							<ButtonStandard size="large">My Dashboard</ButtonStandard>
						</a>
						<a href="/logout">
							<ButtonStandard size="large" color="red">
								Logout
							</ButtonStandard>
						</a>
					</div>
				</div>
			</div>
		</PYSurveyContainer>
	);
};
